import DropdownButton from './DropdownButton'
import DropdownContent from './DropdownContent'
import { useState, useEffect, useRef } from "react"
import styles from './Dropdown.module.css';


// variant="compact": versión chica usada en el buscador del Navbar.
const Dropdown = ({ buttonText, content, closeOnClick = true, variant }) => {

    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();

    const toggleDropdown = () => {
        setOpen((open) => !open)
    };

    useEffect(() => {
        const handler = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("click", handler);

        return () => {
            document.removeEventListener("click", handler);
        };
    }, [dropdownRef]);

    return (
        <div ref={dropdownRef} className={`dropdown ${styles.dropdown} ${variant === 'compact' ? styles.compact : ''}`} >
            <DropdownButton toggle={toggleDropdown} open={open}>{buttonText}</DropdownButton>
            <DropdownContent open={open} toggle={toggleDropdown} closeOnClick={closeOnClick}>{content} </DropdownContent>
        </div>
    )
}

export default Dropdown